// Controls
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface } from "@fluentui/react-components";
import { DialogTitleWithDismiss } from "../dialogTitleWithDismiss/DialogTitleWithDismiss";
// Styles
import { useConfirmationDialogStyles } from "./ConfirmationDialog.styles";
// Utilities
import * as React from "react";
import { customizeStyles } from "../utilities/StyleUtilities";
/**
 * Generic ConfirmationDialog component for any confirmation scenario
 */ export const ConfirmationDialog = (props)=>{
    const { title, message, primaryButtonText, secondaryButtonText, onPrimaryAction, onDismiss, onSecondaryAction, secondaryMessage, primaryButtonAppearance = "primary", secondaryButtonAppearance = "secondary", content, customStyles, dataTestId } = props;
    const styles = customizeStyles(useConfirmationDialogStyles(), customStyles);
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: true,
        onOpenChange: (event, data)=>data.open === false && onDismiss()
    }, /*#__PURE__*/ React.createElement(DialogSurface, {
        "data-testid": dataTestId ?? "confirmation-dialog",
        className: styles.dialogSurface,
        backdrop: {
            className: styles.backdrop
        },
        "aria-label": title
    }, /*#__PURE__*/ React.createElement(DialogTitleWithDismiss, {
        title: title,
        onDismiss: onDismiss
    }), /*#__PURE__*/ React.createElement(DialogBody, null, /*#__PURE__*/ React.createElement(DialogContent, null, content, /*#__PURE__*/ React.createElement("div", {
        className: styles.message
    }, message), secondaryMessage && /*#__PURE__*/ React.createElement("div", {
        className: styles.secondaryMessage
    }, secondaryMessage))), /*#__PURE__*/ React.createElement(DialogActions, {
        className: styles.dialogActions
    }, secondaryButtonText && /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "confirmation-dialog-secondary-button",
        appearance: secondaryButtonAppearance,
        className: styles.actionButtons,
        onClick: onSecondaryAction
    }, secondaryButtonText), /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "confirmation-dialog-primary-button",
        appearance: primaryButtonAppearance,
        className: styles.actionButtons,
        onClick: onPrimaryAction
    }, primaryButtonText))));
};
